import React from 'react';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import {
  Button,
  Dialog,
  DialogContent,
  IconButton,
  CircularProgress,
} from '@mui/material';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';

import styles from './UnsavedChangesDialog.module.scss';

export interface UnsavedChangesDialogProps {
  open: boolean;
  onClose: () => void;
  onSaveAndExit: () => Promise<void> | void;
  onDiscardAndExit: () => void;
  saving?: boolean;
}

const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({
  open,
  onClose,
  onSaveAndExit,
  onDiscardAndExit,
  saving = false,
}) => {
  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: styles.paper }}>
      <IconButton className={styles.closeButton} onClick={onClose} size="large">
        <HighlightOffRoundedIcon fontSize="large" />
      </IconButton>
      <DialogContent className={styles.content}>
        <div className={styles.iconWrapper}>
          <WarningAmberRoundedIcon className={styles.icon} />
        </div>
        <div className={styles.title}>
          Are you sure you want to exit without saving?
        </div>
        <div className={styles.actions}>
          <Button
            variant="contained"
            color="warning"
            onClick={onSaveAndExit}
            disabled={saving}
            className={styles.primaryButton}
          >
            {saving ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              'Save & Exit'
            )}
          </Button>
          <Button
            variant="outlined"
            color="inherit"
            onClick={onDiscardAndExit}
            disabled={saving}
            className={styles.secondaryButton}
          >
            Discard & Exit
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default UnsavedChangesDialog;
